export default __webpack_public_path__ + "static/media/运动场.c6f5badd.jpg";